import React from "react";
import { Route } from "react-router-dom";
import "./App.css";
import EduSignIn from "./components/Educator/signin";
import EduRegister from "./components/Educator/signup";
import Home from "./components/Home/Home";
import signUp from "./components/StudentAuth/Auth"
import TeacherHome from "./components/Educator/TeacherHome/TeacherHome";
import Settings from "./components/Educator/TeacherSettings/Settings"
import TeacherSchedule from "./components/Educator/TeacherSchedule/TeacherSchedule";
import Profile from "./components/Educator/TeacherProfile/TeacherProfile";
import TeacherVideos from "./components/Educator/TeacherVideos/TeacherVideos";
// import TeacherChat from "./components/Educator/TeacherChat/TeacherChat"
// import TeacherChat
import StudentHome from "./components/Student/StudentDashboard/StudentHome/StudentHome";
import StudentProfile from "./components/Student/StudentProfile/StudentProfile";
import StudentVideos from "./components/Student/StudentDashboard/StudentVideos/StudentVideos";
import StudentMeet from "./components/Student/StudentDashboard/StudentMeet/StudentMeet";
import StudentNotes from "./components/Student/StudentDashboard/StudentNotes/StudentNotes";
import SmartHelp from "./components/Student/StudentDashboard/SmartHelp/SmartHelp";
import Register from "./components/StudentAuth/register";
import VideoCall from "./components/agora/VideoCall";
import LiveClassForm from "./components/Educator/TeacherLiveClass/LiveClasses";
import LiveClassSchedule from "./components/Educator/TeacherLive/TeacherLiveClass";
import TeacherLiveVideos from "./components/Educator/TeacherLiveClassForm/TeacherForm";
import StudentSessions from "./components/Student/StudentDashboard/StudentLiveClasses/StudentLiveClass";
function App() {
  return (
    <div>
      {/* <NavBar/> */}
      <section>
        <Route path="/" exact component={Home} />
      </section>
      <section>
        <Route path="/student/login" exact component={signUp}/>
      </section>
      <section>
        <Route path="/student/register" exact component={Register}/>
      </section>
      <section>
        <Route path="/educator/login" exact component={EduSignIn} />
      </section>
      <section>
        <Route path="/educator/register" exact component={EduRegister} />
      </section>
      <section>
        <Route path="/auth" exact component={signUp} />
      </section>
      <section>
        <Route path="/educator" exact component={TeacherHome}/>
      </section>
      <section>
        <Route path="/educator/settings" component={Settings} />
      </section>
      <section>
        <Route path="/educator/myvideos" component={TeacherVideos} />
      </section>
      <section>
        <Route path="/educator/schedule" component={TeacherSchedule} />
      </section>
      <section>
        <Route path="/educator/addVideo" component={LiveClassForm}/>
      </section>
      <section>
        <Route path="/educator/profile" component={Profile} />
      </section>
      <section>
        <Route path="/educator/liveClassSchedule" exact component={LiveClassSchedule}/>
      </section>
      <section>
        <Route path="/educator/liveClasses" exact component={TeacherLiveVideos}/>
      </section>
      <section>
        {/* <Route path="/educator/chat" component={TeacherChat} /> */}
      </section>
      <section>
        <Route path="/student" exact component={StudentHome} />
      </section>
      <section>
        <Route path="/student/myvideos" exact component={StudentVideos} />
      </section>
      <section>
        <Route path="/student/profile" exact component={StudentProfile} />
      </section>
      <section>
        <Route path="/student/smarthelp" exact component={SmartHelp} />
      </section>
      <section>
        <Route path="/student/meet" exact component={StudentMeet} />
      </section>
      {/* <section>
        <Route path="/educator/profile" exact component={Profile}/>
      </section> */}
      <section>
        <Route path="/student/liveClassSchedule" exact component={StudentSessions}/>
        </section>
        <section>
        <Route path="/student/notes" exact component={StudentNotes} />
      </section>
      {/* <section>
        <Route path="/educator/profile" exact component={Profile}/>
      </section> */}
      <section>
        <Route exact path="/call/:sessionId" component={VideoCall} />
      </section>
    </div>
  );
}

export default App;
